import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

interface Props {
  icon: React.ReactNode;
  text: React.ReactNode;
}

export default function ReportNote({ icon, text }: Props) {
  return (
    <Stack
      direction="row"
      spacing={1.25}
      sx={{
        alignItems: 'flex-start',
        bgcolor: 'grey.50',
        borderBottom: 1,
        borderColor: 'divider',
        color: 'text.secondary',
        p: 2,
      }}
    >
      <Box sx={{ color: 'info.main', display: 'flex', mt: 0.125 }}>{icon}</Box>
      <Typography variant="body2">{text}</Typography>
    </Stack>
  );
}
